import { call, put, takeEvery } from "redux-saga/effects";
import { setUser, setUserAccess, setUserAccessFailureMessage } from "./userSlice";
import axios from "axios";


function*   setUserDetails(action: any) {
    yield put(setUser(action.payload));
}
function*   checkUserAccess(event: any) {
    try {
        const response: any = yield axios.get("/user/checkaccess", {
            // ...event.payload,
        });
        let data = response.data;

        const userDetails = {            
            displayName: data?.Name,
            givenName: data?.Name,
            mail: data?.Email,
            roleId: data?.RoleId,
            ...data
        }
        sessionStorage.setItem('userDetail', JSON.stringify(userDetails));
        yield call(setUserDetails, { payload: { ...userDetails, ...event.payload } })
        yield put(setUserAccess(true as any));
    } catch (error: any) {
        yield put(setUserAccess(false as any));
        yield put(setUserAccessFailureMessage((error?.response?.data?.error ?? {})));
    }
}
export function* userSaga() {
    yield takeEvery("SET_USER_DETAILS", setUserDetails);
    yield takeEvery("CHECK_USER_ACCESS", checkUserAccess);
}